import { Box } from "../Box/index.mjs";
import { jsx } from "react/jsx-runtime";
const VisuallyHidden = ({
  children,
  visible,
  ...props
}) => visible ? children : /* @__PURE__ */jsx(Box, {
  position: "absolute",
  width: 1,
  height: 1,
  margin: -1,
  zIndex: -1e4,
  overflow: "hidden",
  opacity: 1e-8,
  pointerEvents: "none",
  ...props,
  children
});
export { VisuallyHidden };